var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import '../styles/saveWorkModal.scss';
import ButtonComponent from './ButtonComponent';
import Popup from './Popup';
import { t } from 'i18next';
import InputBox from './InputBox';
import CustomScrollbar from './CustomScrollbar';
import { getImageSrc } from '../helper/imageBlobCache';
import { API_BASE_URL } from '../config/api';
import { formatShareCode } from '../helper/shareCode';
import { rememberOwnShareCode } from '../helper/ownShareCodes';
import globalStore from '../store';
import { extractUserSaveState } from '../middleware/jsonMiddleware';
import { clearDraftForCurrentActivity } from '../helper/unsavedDraft';
import { postShareCodeSave } from '../helper/saveShareCode';
import { trackEvent, AnalyticsCategory } from '../helper/analytics';
import { withBusy } from '../helper/busyOverlay';
import { normalizeShareCode } from '../helper/shareCode';
import { DataContext } from '../player/DataContext';
/** Find an entry by normalized share code across the groups tree. */
var findEntryByCode = function (sections, code) {
    var target = normalizeShareCode(code);
    if (!target)
        return null;
    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
        var section = sections_1[_i];
        if (section.entries) {
            var entry = section.entries.find(function (e) { return normalizeShareCode(e.code) === target; });
            if (entry)
                return entry;
        }
        if (section.children) {
            var found = findEntryByCode(section.children, code);
            if (found)
                return found;
        }
    }
    return null;
};
var SaveWorkModal = function (props) {
    var showModal = props.showModal, setShowModal = props.setShowModal, _a = props.code, code = _a === void 0 ? '' : _a, onSave = props.onSave, _b = props.title, title = _b === void 0 ? t('text.saveYourWork') : _b, _c = props.subtitle, subtitle = _c === void 0 ? t('text.saveOrEnterName') : _c, _d = props.regenerateCode, regenerateCode = _d === void 0 ? true : _d, onCancel = props.onCancel;
    var _e = useState(''), nameVal = _e[0], setNameVal = _e[1];
    var _f = useState(''), generatedCode = _f[0], setGeneratedCode = _f[1];
    var _g = useState(false), isGeneratingCode = _g[0], setIsGeneratingCode = _g[1];
    var _h = useState(false), isSaving = _h[0], setIsSaving = _h[1];
    var _j = globalStore.useStoreState(function (state) { return state.playerStore; }), pageData = _j.pageData, productionBaseline = _j.productionBaseline, activityMeta = _j.activityMeta, isIDM = _j.isIDM, isSwp = _j.isSwp, username = _j.username, currentPage = _j.currentPage, playerBgPattern = _j.playerBgPattern, zoomLevel = _j.zoomLevel, contentShareable = _j.contentShareable, language = _j.language;
    var groupSections = globalStore.useStoreState(function (state) { return state.groupsStore; }).sections;
    var fetchGroups = globalStore.useStoreActions(function (state) { return state.groupsStore; }).fetchGroups;
    var _k = globalStore.useStoreActions(function (state) { return state.playerStore; }), setShareCode = _k.setShareCode, setIsAdmin = _k.setIsAdmin;
    // Live state for the page the user is currently on. The eager pageData
    // sync was removed to fix next/back contamination, so we now merge the
    // live DataContext state into pageData at save time — current page from
    // here, every other page from the playerStore snapshot.
    var _l = useContext(DataContext), manipulative = _l.manipulative, text = _l.text, table = _l.table, annotations = _l.annotations, shades = _l.shades, drawCommands = _l.drawCommands, manipulativeBtnState = _l.manipulativeBtnState, coinsAndCountersDrawer = _l.coinsAndCountersDrawer;
    var buildMergedPageData = function () {
        var liveCurrent = {
            widgets: manipulative,
            text: text,
            table: table,
            annotations: annotations,
            shades: shades,
            drawCommands: drawCommands,
            zoomLevel: zoomLevel,
            coinsAndCountersDrawer: coinsAndCountersDrawer,
        };
        var idx = Math.max(0, currentPage - 1);
        // `pageData` is empty for fresh non-IDM activities — `loadActivityData`
        // early-returns when there's no IDM context and no share code, so the
        // pagesData array is never built. A naive `pageData.map(...)` would
        // then produce `[]` and the save payload would land with empty
        // `workspaces`, dropping anything the user dropped on the canvas. Pad
        // the array up to the current page index so the live state still
        // surfaces in `workspaces[idx]`.
        if (idx >= pageData.length) {
            var emptyPage = {
                widgets: [],
                text: [],
                table: [],
                annotations: [],
                shades: [],
                drawCommands: [],
                coinsAndCountersDrawer: [],
            };
            var padded = __spreadArray([], pageData, true);
            while (padded.length <= idx)
                padded.push(__assign({}, emptyPage));
            padded[idx] = __assign(__assign({}, padded[idx]), liveCurrent);
            return padded;
        }
        return pageData.map(function (page, i) { return (i === idx ? __assign(__assign({}, page), liveCurrent) : page); });
    };
    // Fetch a fresh share code each time the modal opens — unless the caller
    // wants to re-save an existing code (regenerateCode === false), in which case
    // we leave `generatedCode` empty so `effectiveCode` falls back to `code`.
    useEffect(function () {
        if (!showModal || !regenerateCode)
            return;
        var cancelled = false;
        setIsGeneratingCode(true);
        setGeneratedCode('');
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, body, fetched, _a;
            var _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _h.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, fetch("".concat(API_BASE_URL, "share-codes/generate"), {
                                method: 'POST',
                                credentials: 'include',
                                headers: { 'Content-Type': 'application/json' },
                            })];
                    case 1:
                        res = _h.sent();
                        if (!res.ok)
                            return [2 /*return*/];
                        return [4 /*yield*/, res.json().catch(function () { return null; })];
                    case 2:
                        body = _h.sent();
                        fetched = (_g = (_f = (_d = (_c = (_b = body === null || body === void 0 ? void 0 : body.data) === null || _b === void 0 ? void 0 : _b.shareCode) !== null && _c !== void 0 ? _c : body === null || body === void 0 ? void 0 : body.shareCode) !== null && _d !== void 0 ? _d : (_e = body === null || body === void 0 ? void 0 : body.data) === null || _e === void 0 ? void 0 : _e.code) !== null && _f !== void 0 ? _f : body === null || body === void 0 ? void 0 : body.code) !== null && _g !== void 0 ? _g : '';
                        if (!cancelled)
                            setGeneratedCode(fetched);
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _h.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        if (!cancelled)
                            setIsGeneratingCode(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            cancelled = true;
        };
    }, [showModal, regenerateCode]);
    var effectiveCode = generatedCode || code;
    // Save is gated on a non-empty label so users can't ship un-named work
    // (the saved entry would be hard to identify in the folders panel later).
    var trimmedName = nameVal.trim();
    var canSave = !!trimmedName && !!effectiveCode && !isSaving;
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var rawJson, existingLabel, labelToSend, _a;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (!canSave)
                        return [2 /*return*/];
                    setIsSaving(true);
                    rawJson = extractUserSaveState(buildMergedPageData(), productionBaseline !== null && productionBaseline !== void 0 ? productionBaseline : null, {
                        username: username !== null && username !== void 0 ? username : '',
                        activityUUID: (_d = (_c = (_b = productionBaseline === null || productionBaseline === void 0 ? void 0 : productionBaseline.meta) === null || _b === void 0 ? void 0 : _b.activityUUID) !== null && _c !== void 0 ? _c : activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.activityId) !== null && _d !== void 0 ? _d : '',
                    }, manipulativeBtnState, playerBgPattern, language);
                    // "Save As" (duplicate) takes the exact same payload as a plain Save: the
                    // copy is the complete live state — manipulative positions, annotations,
                    // freehand drawCommands, texts, tables, shades, zoom. There is deliberately
                    // no special case here; a copy that differed from what Save persists would
                    // silently lose the user's work.
                    // Tag the payload with the current IDM URL so the backend can associate
                    // this share code with the activity it was saved from.
                    if (isIDM || isSwp) {
                        rawJson.meta = __assign(__assign({}, ((_e = rawJson.meta) !== null && _e !== void 0 ? _e : {})), { url: window.location.pathname, 
                            // Persist the authored share rule alongside the URL. A share-code load
                            // never fetches the activity's initial JSON, so this is the only record
                            // that the content was marked non-shareable.
                            shareable: contentShareable });
                    }
                    existingLabel = (_g = (_f = findEntryByCode(groupSections, effectiveCode)) === null || _f === void 0 ? void 0 : _f.label) !== null && _g !== void 0 ? _g : '';
                    labelToSend = nameVal.trim() || existingLabel;
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var saveRes, hyphenated;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, postShareCodeSave({
                                            sharecode: effectiveCode,
                                            label: labelToSend,
                                            raw_json: rawJson,
                                            // Saving is the opposite of the share-only mint in InputWithBtn's
                                            // `handleShareCurrentWorkspace`: it clears the flag, so a code the
                                            // user first handed out via Share becomes a normal row in the
                                            // saved-work list once they name it here.
                                            shareOnly: false,
                                        })];
                                    case 1:
                                        saveRes = _a.sent();
                                        // The work now lives on the server under this share code, so the
                                        // localStorage draft that was standing in for it has no job left. Only
                                        // a SUCCESSFUL save clears it — a non-2xx response does not throw, so
                                        // without the `ok` check a rejected save would delete the only
                                        // remaining copy of the user's work.
                                        if (saveRes.ok)
                                            clearDraftForCurrentActivity();
                                        // Track the save, distinguishing whether the user gave their work a label.
                                        trackEvent(AnalyticsCategory.save, 'save', labelToSend ? 'labeled' : 'unlabeled');
                                        hyphenated = formatShareCode(effectiveCode);
                                        rememberOwnShareCode(hyphenated);
                                        setShareCode(hyphenated);
                                        // The current user just created this share code, so they own it. The
                                        // ownership flag (isAdmin) was last computed by checkAuth against the
                                        // PREVIOUS share code and isn't re-derived when we swap shareCode here,
                                        // so without this it stays stale (edit tools locked) until a refresh
                                        // re-runs checkAuth. Set it directly — the payload was saved with
                                        // meta.username = current user, so a later refresh derives the same.
                                        setIsAdmin(true);
                                        // Keep the IDM activity path in the URL — only swap the query string
                                        // for the new share code. Passing a bare `?abc` to replaceState relies
                                        // on relative-URL resolution which can drop the path under some
                                        // routing configurations; spelling out the pathname avoids that.
                                        window.history.replaceState(null, '', "".concat(window.location.pathname, "?").concat(hyphenated).concat(window.location.hash));
                                        // Refresh the groups list so the newly-saved share code surfaces in
                                        // the InputWithBtn panel without requiring a full reload. Awaited so
                                        // the busy overlay stays up until the new entry is in hand.
                                        return [4 /*yield*/, fetchGroups()];
                                    case 2:
                                        // Refresh the groups list so the newly-saved share code surfaces in
                                        // the InputWithBtn panel without requiring a full reload. Awaited so
                                        // the busy overlay stays up until the new entry is in hand.
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 2:
                    _h.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _h.sent();
                    return [3 /*break*/, 5];
                case 4:
                    onSave === null || onSave === void 0 ? void 0 : onSave(effectiveCode, nameVal);
                    setShowModal(false);
                    setNameVal('');
                    setGeneratedCode('');
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        setShowModal(false);
        setNameVal('');
        setGeneratedCode('');
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    };
    return (_jsx(Popup, { isOpen: showModal, onClose: handleCancel, children: _jsxs("div", { className: "swm-container", children: [isGeneratingCode && (_jsx("div", { className: "swm-loader", role: "status", "aria-live": "polite", children: _jsx("img", { src: getImageSrc('./assets/images/loader.gif'), alt: t('text.loading', { defaultValue: 'Loading' }), draggable: false }) })), _jsxs("div", { className: "swm-content", style: { visibility: isGeneratingCode ? 'hidden' : 'visible' }, "aria-hidden": isGeneratingCode, inert: isGeneratingCode || undefined, children: [_jsxs(CustomScrollbar, { className: "swm-scrollbar", direction: "vertical", children: [_jsx("h1", { className: "swm-title", children: title }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsxs("div", { className: "swm-fields", children: [_jsxs("div", { className: "swm-field", children: [_jsx("div", { className: "swm-label", children: " " }), _jsx(InputBox, { id: "saveWorkCode", type: "text", defaultCSS: 'inputBox swm-codeInput', value: formatShareCode(effectiveCode, ' - '), disabled: true, ariaLabel: t('text.enterCode') })] }), _jsxs("div", { className: "swm-field", children: [_jsx("div", { className: "swm-label", children: t('text.enterName') }), _jsx(InputBox, { id: "saveWorkName", type: "text", defaultCSS: 'inputBox', value: nameVal, placeholder: t('text.typeHere'), autoFocus: true, onInput: function (_id, val) { return setNameVal(val); }, onKeyDown: function (e) {
                                                        if (e.key === 'Enter')
                                                            handleSave();
                                                    } })] })] }), _jsxs("div", { className: "swm-buttons", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.cancel'), defaultCSS: "swm-btn swm-cancelBtn", normalCSS: "swm-cancelBtn", clickHandler: handleCancel, visibility: isGeneratingCode }), _jsx(ButtonComponent, { type: "textType1", text: t('text.save'), defaultCSS: "swm-btn swm-saveBtn", normalCSS: "swm-saveBtn", clickHandler: handleSave, visibility: isGeneratingCode, disabled: !canSave })] })] }), _jsx("div", { className: "swm-footer", children: _jsx("img", { src: getImageSrc('./assets/images/popupColorPatch.svg'), tabIndex: -1, alt: "" }) })] })] }) }));
};
export default SaveWorkModal;
